import trierIntervenants from '@/services/devisCommandes/trierIntervenants';
import { getAll } from '@/api/devis/index';
import * as devisConf from '@/configuration/devisConf';
import gestionDateBase from '@/services/general/gestionDateBase';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import * as types from './devis-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    devis: [],
    totalDevis: 0,
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_DEVIS](state, devis) {
    state.devis = devis;
  },
  [types.SET_TOTAL_DEVIS](state, totalDevis) {
    state.totalDevis = totalDevis;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
};

const actions = {
  async loadDevis({ commit }, data) {
    data.query.type = devisConf.TYPE_DEVIS;
    commit(types.SET_LAST_PAYLOAD, data);
    const response = await getAll(data);
    response.data.result.items.forEach((devis) => {
      devis.selected = false;
      devis.dateDevisCommande = gestionDateBase(devis.dateDevisCommande);
      const etat = devisConf.DEVIS_COMMANDE_ETAT.find((el) => {
        return el.code === devis.etat;
      });
      if (etat) devis.etatLibelle = etat.libelle;
      if (devis.commercial) devis.nomCommercial = nomPrenomGetter(devis.commercial);
      let listeIntervenants = '';
      trierIntervenants(devis);
      listeIntervenants = devis.intervenants.map((el) => el.nomCommercial).join(', ');
      devis.listeIntervenants = listeIntervenants;
    });
    commit(types.SET_TOTAL_DEVIS, response.data.result.totalCount);
    commit(types.SET_DEVIS, response.data.result.items);
    return {};
  },
};

const getters = {
  devis: state => {
    return state.devis;
  },
  totalDevis: state => {
    return state.totalDevis;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
